<template>
  <div>
    <el-row style="padding: 30px 0;">
      <el-col :span="9" class="text-blueGrey" style="line-height: 28px;text-align: right;margin-right: 10px;">
        呈现方式：
      </el-col>
      <el-col :span="14" style="padding-top: 6px;">
        <el-radio-group @change="val => change(val)" v-model="selected">
          <el-radio :key="item.id" :label="item.label" v-for="item in selectList">{{ item.name }}</el-radio>
        </el-radio-group>
      </el-col>
    </el-row>
  </div>
</template>

<script>

export default {
  name: "DisplaySetting",
  props: ['viewMode', 'selectList'],
  data() {
    return {
      selected: '',
    }
  },
  watch: {
    viewMode() {
      this.selected = this._.cloneDeep(this.viewMode)
    }
  },
  mounted() {
    this.selected = this._.cloneDeep(this.viewMode)
  },
  methods: {
    change(val) {
      this.$emit('getDisplayMode', val)
    }
  }
}
</script>

<style scoped>

</style>
